export default __webpack_public_path__ + "static-front/media/MailIcon.d5dfb425.svg";